/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconArticle.vue?vue&type=template&id=16362bd2"
import script from "./IconArticle.vue?vue&type=script&lang=js"
export * from "./IconArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16362bd2')) {
      api.createRecord('16362bd2', component.options)
    } else {
      api.reload('16362bd2', component.options)
    }
    module.hot.accept("./IconArticle.vue?vue&type=template&id=16362bd2", function () {
      api.rerender('16362bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconArticle.vue"
export default component.exports